const translations = {
    addProduct: '+ Add Product',
    library: 'Library',
    mixes: 'Mixes',
    newMix: 'New Mix',
    pageSubtitle: 'Saved mixes and chemical library.',
    pageTitle: 'Chemicals',
    searchButton: 'Search',
    searchPlaceholder: 'Search by product name or EPA number...'
};

export default translations;
